import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderByUID } from '@/hooksApi/useOrder';
import { TimelineItemProps } from '@/components/OrderTracker/OrderTracker';
import { OrderStatusEnum } from '@/config';
import { formatDateByDayjs, mapOrderStatusToValue } from '@/utils';

const useOrderTimeline = (orderId: string) => {
  const { t } = useTranslation();
  const { data, isLoading } = useOrderByUID(orderId);

  const timelineItems = useMemo(() => {
    if (!data?.object?.statuses) return [] as TimelineItemProps[];

    return [...data.object.statuses]
      .sort((a, b) => {
        // Sort by pivot created_at ascending (oldest first), then reverse for newest-first display
        const ta = new Date(a?.pivot?.created_at || 0).getTime();
        const tb = new Date(b?.pivot?.created_at || 0).getTime();
        return ta - tb;
      })
      .map((status) => ({
        day: formatDateByDayjs(status?.pivot?.created_at, 'DD'),
        month: formatDateByDayjs(status?.pivot?.created_at, 'MMMM'),
        time: formatDateByDayjs(status?.pivot?.created_at, 'hh:mm'),
        title: status?.merchant_title || (status?.slug ? String(t(`merchant_title_order_status.${status.slug}`)) : status?.title),
        description: 'description',
        status: mapOrderStatusToValue(status?.title as OrderStatusEnum) || 'created',
        carrier: data?.object?.carrier,
      }))
      .reverse();
  }, [data, t]);

  return { timelineItems, isLoading, data };
};

export default useOrderTimeline;
